<template>
  <table class="responsive-table">
    <thead>
      <tr>
        <th v-for="col in columns" :key="col.id" @click="emitSort(col)">
          {{ col.display_label }}
          <template v-if="col.sortable">
            <font-awesome-icon :icon="['fas', 'sort']" class="icon alt" />
            <span v-if="col.id == sortedColumn" :class="sortedAsc ? 'active-up' : 'active-down'">
              <font-awesome-icon :icon="['fas', 'sort-down']" class="icon alt" />
              <font-awesome-icon :icon="['fas', 'sort-up']" class="icon alt" />
            </span>
          </template>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in clients" :key="row.id">
        <td>
          {{ row.client.firstName + ' ' + row.client.lastName || 'N/A' }}

          <label class="d-block d-md-none">
            Client Name:
          </label>
        </td>
        <td>
          {{ (row.school && row.school.name) || 'N/A' }}

          <label class="d-block d-md-none">
            School:
          </label>
        </td>
        <td>
          {{ row.client.email || 'N/A' }}

          <label class="d-block d-md-none">
            Email:
          </label>
        </td>
        <td>
          {{ row.client.phoneNumber || 'N/A' }}

          <label class="d-block d-md-none">
            Phone Number:
          </label>
        </td>
        <td v-if="row.lastAppointment">
          {{ moment(row.lastAppointment).toDate() | date }}

          <label class="d-block d-md-none">
            Last Appt:
          </label>
        </td>
        <td v-else>
          N/A
          <label class="d-block d-md-none">
            Last Appt:
          </label>
        </td>

        <td>
          {{ getPatientType(row.isGroupSessionClient, row.isIndividualSessionClient) }}

          <label class="d-block d-md-none">
            Client Type:
          </label>
        </td>

        <td class="action-row">
          <router-link :to="`/student/${row.client.clientId}`" tag="a" class="btn btn-ghost first mb-2 mb-md-0">
            <font-awesome-icon :icon="['fas', 'file-alt']" class="icon alt" />
          </router-link>
          <button v-if="isCounselor" class="btn btn-ghost" type="button" @click="scheduleForClient(row)">
            Schedule
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment';
export default {
    name: 'ClientsTable',
    props: {
        clients: {
            type: Array,
            required: true
        },
        scheduleForClient: {
            type: Function,
            required: true
        },
    },
    data() {
        return {
            moment: moment,
            columns: [
                { id: 'displayName', display_label: 'Client Name' },
                { id: 'school_name', display_label: 'School' },
                { id: 'email', display_label: 'Email' },
                { id: 'phoneNumber', display_label: 'Phone #' },
                { id: 'lastAppointment', display_label: 'Last Appointment' },
                { id: 'type', display_label: 'Client Type' },
            ],
        }
    },
    computed: {
        isCounselor() {
            return this.$store.getters.currentUser && this.$store.getters.currentUser.isCounselor;
        },
    },
    methods: {
        emitSort(column) {
            if (column.sortable) this.onSort(column.id);
        },
        getPatientType(isGroupSession, isIndividualSession) {
            let type = 'N/A';
            if (isIndividualSession && isGroupSession) type = 'Individual + Workshop';
            else if (isIndividualSession) type = 'Individual';
            else if (isGroupSession) type = 'Workshop';

            return type;
        }
    }
};
</script>

<style lang="scss" scoped>
.responsive-table {
    @include border-radius($border-radius);

    width: 100%;
    border: none;

    thead {
        background: none;
        color: white;

        th {
            position: relative;
            padding: 0.75rem;
            padding-right: $gutter;
            white-space: nowrap;
            border-bottom: 2px solid rgba(255, 255, 255, 0.25);
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;

            i,
            svg {
                position: absolute;
                top: 17px;
                right: 10px;
            }

            .fa-sort {
                z-index: 1;
                opacity: 0.2;
            }

            span {
                .fa-sort-up {
                    z-index: 2;
                    opacity: 0;
                }

                .fa-sort-down {
                    z-index: 3;
                    opacity: 0;
                }

                &.active-down {
                    .fa-sort-down {
                        opacity: 1;
                    }
                }

                &.active-up {
                    .fa-sort-up {
                        opacity: 1;
                    }
                }
            }

            &:hover {
                .fa-sort {
                    opacity: 0.3;
                }

                span {
                    .fa-sort-down {
                        opacity: 1;
                    }

                    &.active-down {
                        .fa-sort-down {
                            opacity: 1;
                        }

                        .fa-sort-up {
                            opacity: 0;
                        }
                    }

                    &.active-up {
                        .fa-sort-up {
                            opacity: 1;
                        }

                        .fa-sort-down {
                            opacity: 0;
                        }
                    }
                }
            }
        }
    }

    tbody {
        tr {
            td {
                padding: 0.75rem;
                color: rgba(white, 0.87);
                border-top: 1px solid rgba(255, 255, 255, 0.25);

                a {
                    color: darken($highlight-color, 5%);
                }
            }
        }
    }

    .actions {
        text-align: right;
    }

    @media (max-width: $sm-max) {
        display: block;
        border: none;

        thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        tbody {
            tr {
                background: $dark-blue;

                td {
                    padding: 0.75rem;
                    text-align: right;
                    border-bottom: none;
                    border-top: 1px solid rgba(255, 255, 255, 0.25);

                    &:last-of-type {
                        border-bottom: none;
                    }
                }
            }
        }

        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr {
            @include border-radius($border-radius);

            margin: 0 0 1rem 0;
            background: white;
        }

        td {
            position: relative;
            padding-left: 50%;
            border: none;
            border-bottom: $secondary-border;

            label {
                position: absolute;
                top: 12.5px;
                left: 15px;
                width: 45%;
                padding-right: 10px;
                font-weight: bold;
                white-space: nowrap;
                text-align: left;
            }
        }

        .btn-ghost {
            border-color: $primary-color;
            background: $primary-color;
            color: $btn-color;
            height: 45px;

            &:hover,
            &:focus {
                border-color: darken($primary-color, 5%);
                background-color: darken($primary-color, 5%);
                color: $btn-color;
            }
        }
    }

    .action-row {
        white-space: nowrap;

        .btn.first {
            margin-right: 5px;
            .icon {
                @media only screen and (max-width: 800px) {
                    color: $dark-blue;
                }
            }
        }
    }
}
</style>
